import { IPanelStyles } from '@fluentui/react/lib/Panel';
import { FontWeights, IRawStyle, ITheme } from '@fluentui/react/lib/Styling';
import { ContrastColors, CoreColors, DarkColors } from '../teams-colors';

export function getPanelStyles(
  themeName: string,
  theme: ITheme
): Partial<IPanelStyles> {
  const styles = {
    main: {
      selectors: {
        '&.ms-Panel-main': {
          borderWidth: 0,
          borderStyle: 'solid',
          borderColor: theme.palette.black
        },
        '.ms-Checkbox': {
          paddingTop: 12,
          paddingBottom: 0,
          selectors: {
            '.ms-Persona': {
              paddingLeft: 4,
              paddingRight: 4,
              paddingTop: 0,
              paddingBottom: 0
            }
          }
        }
      }
    },
    overlay: {
      backgroundColor: CoreColors.overlayBackground
    },
    closeButton: {
      color: theme.palette.black,
      selectors: {
        '&:hover': {
          color: theme.palette.themePrimary,
          selectors: {
            i: {
              fontWeight: FontWeights.bold
            }
          }
        },
        '&:active': {
          color: theme.palette.themePrimary,
          selectors: {
            i: {
              fontWeight: FontWeights.bold
            }
          }
        }
      }
    },
    content: {
      color: theme.palette.black
    },
    headerText: {
      color: theme.palette.black
    }
  } as Partial<IPanelStyles>;

  // Dark theme overrides
  if (themeName === 'dark') {
    (styles.overlay as IRawStyle).backgroundColor =
      DarkColors.overlayBackground;
  }

  // Contrast theme overrides
  if (themeName === 'contrast') {
    (styles.overlay as IRawStyle).backgroundColor =
      ContrastColors.overlayBackground;

    ((styles.main as Required<IRawStyle>).selectors[
      '&.ms-Panel-main'
    ] as IRawStyle).borderWidth = '2px';

    ((styles.closeButton as Required<IRawStyle>).selectors[
      '&:hover'
    ] as IRawStyle).color = theme.palette.themeDark;
    ((styles.closeButton as Required<IRawStyle>).selectors[
      '&:active'
    ] as IRawStyle).color = theme.palette.themeDark;
  }

  return styles;
}
